const addAdvertisementProperty = (recommendedProductItem, criteoItem) => {
  if (!criteoItem) return recommendedProductItem || [];
  if (!recommendedProductItem) return [];

  const {
    OnBasketChangeBeacon,
    OnClickBeacon,
    OnLoadBeacon,
    OnViewBeacon,
    OnWishlistBeacon,
    ProductId,
    ProductName,
  } = criteoItem;

  return {
    ...recommendedProductItem,
    advertisement: {
      OnBasketChangeBeacon,
      OnClickBeacon,
      OnLoadBeacon,
      OnViewBeacon,
      OnWishlistBeacon,
      ProductId,
      ProductName,
    },
  };
};

export default addAdvertisementProperty;
